export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supershop-pos/:pageId',
        component: () => import('@/views/page/company/super-shop/PosInvoice.vue'),
        name: 'supershop-pos',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/supershop-pos-list/:pageId',
        component: () => import('@/views/page/company/super-shop/PosInvoiceList.vue'),
        name: 'supershop-pos-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-list/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointList.vue'),
        name: 'reward-point-list',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/reward-point-statement/:pageId',
        component: () => import('@/views/page/company/super-shop/RewardPointStatementList.vue'),
        name: 'reward-point-statement',
        meta: {
            requiresAuth: true
        }
    },
]